import React from "react";
import { Check } from "lucide-react";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

export const CaseCards = ({ cases, h2 = "Ergebnisse aus der Praxis", label = "Referenzen" }) => (
  <Section testId="personal-cases" className="has-lines overflow-hidden bg-[#f5f6f4]">
    <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
    <Container>
      <Reveal>
        <Label>{label}</Label>
        <AccentH2 className="mt-6 max-w-[760px] font-bold text-[#1e2532]">{h2}</AccentH2>
      </Reveal>
      <div className={`mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 ${cases.length > 2 ? "lg:grid-cols-3" : ""} lg:gap-7`}>
        {cases.map((cs, i) => (
          <article
            key={cs.name}
            data-testid={`personal-case-${i}`}
            className="card-hover flex h-full flex-col overflow-hidden rounded-[16px] border border-[#dfe2e0] border-t-[3px] border-t-[#0f9d6e] bg-white"
          >
            <div className="flex flex-1 flex-col p-7 md:p-8">
              <div className="flex h-[46px] items-center">
                <img
                  src={cs.logo}
                  alt={`Logo ${cs.name}`}
                  loading="eager"
                  decoding="async"
                  className="h-[var(--ch)] w-auto max-w-[180px] object-contain"
                  style={{ "--ch": `${cs.logoH || 40}px`, filter: "grayscale(1) contrast(1.05)" }}
                />
              </div>
              <h3 className="mt-6 text-[19px] font-semibold leading-[1.3] text-[#1e2532]">{cs.name}</h3>
              <p className="mt-5 text-[15.5px] leading-[1.74] text-[#565f70]">{cs.text}</p>
            </div>
            <div className="mt-auto border-t border-[#e3ece7] bg-[#f2f8f5] px-7 py-6 md:px-8">
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#0b7d57]">Ergebnisse</p>
              <ul className="mt-4 space-y-3">
                {cs.metrics.map((m) => (
                  <li key={m} className="flex gap-3 text-[15px] font-medium leading-[1.55] text-[#1e2532]">
                    <span className="mt-[2px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-[#0f9d6e]">
                      <Check size={11} strokeWidth={3} className="text-white" />
                    </span>
                    {m}
                  </li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </Container>
  </Section>
);
